export default __webpack_public_path__ + "static/guibord-fbe78742fc9aee5362a2d14f5fd8bfeb.jpeg";